export default __webpack_public_path__ + "static/media/t_wdt_c_3.3b22b35d.mp3";